import api from "../../../../shared/api";
import { IResponse } from "../../../../shared/types/api";
import { getFormData } from "../../../../shared/utils/formData";
import { TLoginData, TAuthResponse } from "../types/types";

const signInApi = api.injectEndpoints({
  endpoints: (build) => ({
    authSignIn: build.query<IResponse<TAuthResponse>, TLoginData>({
      query: (body: TLoginData) => {
        return {
          url: "/auth/signin",
          method: "POST",
          body: getFormData(body),
        };
      },
    }),

    sendCode: build.query<IResponse<TAuthResponse>, string>({
      query: (code) => {
        return {
          url: "/auth/signin/2fa",
          method: "POST",
          body: getFormData({ code }),
        };
      },
    }),

    resendSms: build.query<void, void>({
      query: () => "/auth/signin/2fa/resend-sms",
    }),

    send2Email: build.query<void, void>({
      query: () => "/auth/signin/2fa/resend-email",
    }),
  }),
});
export const {
  useLazyAuthSignInQuery,
  useLazySendCodeQuery,
  useLazyResendSmsQuery,
  useLazySend2EmailQuery,
} = signInApi;
